import { render, staticRenderFns } from "./verified-companies.vue?vue&type=template&id=166d3c46"
import script from "./verified-companies.vue?vue&type=script&lang=js"
export * from "./verified-companies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports